module.exports = __webpack_public_path__ + "img/404.a2769ff4.png";